var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1.25C2.58579 1.25 2.25 1.58579 2.25 2C2.25 2.41421 2.58579 2.75 3 2.75H6.27924C6.38685 2.75 6.48238 2.81886 6.51641 2.92094L7.54276 6H7.05936C6.48443 6 6.02791 6.48362 6.06102 7.0576L6.15464 8.6803C7.89608 8.51241 9.65784 8.67803 11.3445 9.17277L11.461 9.20697C13.5296 9.81376 15.7184 9.863 17.8065 9.35468L17.939 7.0576C17.9721 6.48362 17.5156 6 16.9407 6H9.1239L7.93944 2.4466C7.70124 1.732 7.03249 1.25 6.27924 1.25H3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0388 10.6463C13.2143 11.2845 15.5082 11.3732 17.7166 10.9126L17.1313 21.0576C17.1008 21.5866 16.6629 22 16.133 22H7.86703C7.33712 22 6.89921 21.5866 6.86869 21.0576L6.24109 10.1791C7.81125 10.0202 9.40104 10.1659 10.9222 10.6121L11.0388 10.6463Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeverage);
export default __webpack_public_path__ + "static/media/beverage.7e1eb3a6185ac35e2f978d0e76edfd0e.svg";
export { ForwardRef as ReactComponent };